/**
 * DpScreenModelService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DpScreenModelService {
    getScreenModelsOptions = () => {
        return apiClient.get("/getScreenModels");
    }

    createScreenModel = (body) => {
        return apiClient.post("/strategy", body);
    }

    editScreenModel = (body) => {
        return apiClient.post("/editstrategy", body);
    }

    getScreenModels = (body) => {
        return apiClient.post("/getScreenModels", body);
    }

    deleteScreenModel = (id) => {
        return apiClient.post("/deletestrategy", { id });
    }

    getMetricsOptions = () => {
        return apiClient.get("/getAllMetrics");
    }
}
